import { render, staticRenderFns } from "./item-block-render.vue?vue&type=template&id=9cb37918&scoped=true"
import script from "./item-block-render.vue?vue&type=script&lang=js"
export * from "./item-block-render.vue?vue&type=script&lang=js"
import style0 from "./item-block-render.vue?vue&type=style&index=0&id=9cb37918&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb37918",
  null
  
)

export default component.exports